import React from 'react';
import { Modal, ModalHeader, Button } from 'reactstrap';
import { DeletePrinterPoint } from './DeletePrinterPoint';
import { FormPrinterPoint } from './FormPrinterPoint';
import { Dialog } from 'primereact/dialog';


export const ModalPrinterPoint = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones,
        saveCreate, saveUpdate, saveDelete, mSelectBranch, branches
    } = props;

    const labelButton = method === "create" 
    ? "Crear nuevo punto de impresión" 
    : method === "update" 
        ? "Actualizar pinto de impresión" 
        : "Confirmar";

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

           <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                {loading ? "Procesando..." : labelButton}
            </Button>

        </div>
    );


    return (
        <Dialog
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}>
            
            {
                method === "create" ?
                    <FormPrinterPoint
                        button="Crear nuevo punto de impresión"
                        {...{ loading, name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones, mSelectBranch, branches, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormPrinterPoint
                            button="Actualizar punto de impresión"
                            {...{ loading, name, username, password, password_confirmation, handleInputChange, handleSelectValues, validaciones, mSelectBranch, branches, methodAction: saveUpdate }}
                        />
                        : null
            }
        </Dialog>   
    )
}
